/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2021-07-29
 * @description Implementation of youtube utility class.
 * @filename youtube-utilities.ts
 */

import { storageFactory } from "./local-storage-factory";
import { LocalStorageKeys } from "./local-storage-keys";

const LOCAL_STORE = storageFactory(() => localStorage);

/**
 * A collection of utilities for AWS S3.
 */
export class YoutubeUtilities {
  /**
   *
   *
   * @static
   * @param {*} url
   * @returns {string}
   * @memberof YoutubeUtilities
   */
  static extractVideoId(url): string {
    if (typeof url !== "string") {
      return null;
    }
    if (url.includes("youtube.com")) {
      return url.substring(url.indexOf("v=") + 2).split("&")[0];
    } else if (url.indexOf("youtu.be") !== -1) {
      return url.substring(url.indexOf("youtu.be") + 9);
    }
  }

  /**
   *
   *
   * @static
   * @param {string} videoId
   * @param {(string | number | boolean)} meta
   * @memberof YoutubeUtilities
   */
  static saveVideoMetaData(videoId: string, meta: string | number | boolean): void {
    let LOOK_UP_DATA: any = LOCAL_STORE.getItem(LocalStorageKeys.KEY_LOCAL_STORAGE_YOUTUBE_PLAY_TIME);
    if (LOOK_UP_DATA) {
      LOOK_UP_DATA = JSON.parse(LOOK_UP_DATA);
      LOOK_UP_DATA[videoId] = meta;
    } else {
      LOOK_UP_DATA = { [videoId]: meta };
    }

    LOCAL_STORE.setItem(LocalStorageKeys.KEY_LOCAL_STORAGE_YOUTUBE_PLAY_TIME, JSON.stringify(LOOK_UP_DATA));
  }

  /**
   *
   *
   * @static
   * @param {*} videoId
   * @returns {(string | number | boolean | undefined)}
   * @memberof YoutubeUtilities
   */
  static extractLocalVideoMeta(videoId): string | number | boolean | undefined {
    let meta: string | number | boolean;

    if (videoId) {
      const LOOK_UP_DATA: any = LOCAL_STORE.getItem(LocalStorageKeys.KEY_LOCAL_STORAGE_YOUTUBE_PLAY_TIME);
      if (LOOK_UP_DATA) {
        meta = JSON.parse(LOOK_UP_DATA)[videoId];
      }
    }

    return meta;
  }

  /**
   *
   *
   * @static
   * @param {string} videoId
   * @memberof YoutubeUtilities
   */
  static removeMetaItem(videoId: string): void {
    if (videoId) {
      let LOOK_UP_DATA: any = LOCAL_STORE.getItem(LocalStorageKeys.KEY_LOCAL_STORAGE_YOUTUBE_PLAY_TIME);
      if (LOOK_UP_DATA) {
        LOOK_UP_DATA = JSON.parse(LOOK_UP_DATA);
        delete LOOK_UP_DATA[videoId];
        LOCAL_STORE.setItem(LocalStorageKeys.KEY_LOCAL_STORAGE_YOUTUBE_PLAY_TIME, JSON.stringify(LOOK_UP_DATA));
      }
    }
  }
}
